import React, { Fragment, Component } from "react";

class HeaderSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allProjects: [],
      hideFilter: false,
      headerSectionData: [],
      isPending: false,
      isSucess: false,
      isError: false,
    };
  }

  componentDidMount() {
    let userProjects = localStorage.getItem("oneviewprojects");
    if (userProjects) {
      userProjects = JSON.parse(userProjects); // Parse the string to an array
      userProjects.sort((a, b) => a.sortOrder - b.sortOrder);
      this.setState({
        allProjects: userProjects,
        selectedProject: localStorage.getItem("selectedProject"),
      });
    }
  }

  toggleFilter = () => {
    this.setState({ hideFilter: !this.state.hideFilter });
  };

  getClassToBeApplied = () => {
    let numberOfKeys = this.state.headerSectionData.length;
    let classToBeApplied = "col-lg-12";
    if (numberOfKeys === 2) {
      classToBeApplied = "col-lg-6";
    } else if (numberOfKeys === 3) {
      classToBeApplied = "col-lg-4";
    } else if (numberOfKeys >= 4) {
      classToBeApplied = "col-lg-3";
    }

    return classToBeApplied;
  };

  onHandleApp = (data) => {
    let token = localStorage.getItem("onevubasicauthtoken");
    if (data.autoLogin === "true") {
      window.open(`${data.projectUrl}verify/${token.slice(6)}`);
    } else {
      window.open(data.projectUrl);
    }
  };

  render() {
    return (
      <Fragment>
        <div className="m-4">
          <div className="bigCard">
            <div
              className="mx-3 mt-3"
              style={{ fontSize: "1.25rem", fontWeight: 500 }}
            >
              Cognitive NOC
            </div>
            <div className="container">
              <div className="row justify-content-md-start ml-4">
                {this.state.allProjects.length > 0 &&
                  this.state.allProjects.map((rowData, index) => {
                    if (rowData.header === "Cognitive NOC") {
                      return (
                        // <div
                        //     // className="col-md-4 card"
                        //     // className="col-md-3 mb-3 card" // Decrease col size and add margin bottom
                        //     className="col-md-4 mb-2 custom-card"
                        //     key={index}
                        //     title={rowData.projectDescription}
                        //     onClick={this.onHandleApp.bind(this, rowData)}>
                        //     {rowData.projectName}
                        // </div>

                        <div
                          className="card cardTitle cardInside1 text-white mx-5 my-4"
                          title={rowData.projectDescription}
                          onClick={this.onHandleApp.bind(this, rowData)}
                          style={{
                            width: "14rem",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                            transition: "transform 0.3s ease",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "scale(0.95)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <div className="card-body d-flex align-items-center justify-content-center">
                            <p className="card-text">{rowData.projectName}</p>
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            </div>
            {/* <div className="divider"></div>
            <div
              className="mx-3"
              style={{ fontSize: "1.25rem", fontWeight: 500 }}
            >
              Design To Rollout
            </div>
            <div className="container">
              <div className="row justify-content-md-start ml-4">
                {this.state.allProjects.length > 0 &&
                  this.state.allProjects.map((rowData, index) => {
                    if (rowData.header === "Design To Rollout") {
                      return (
                        <div
                          className="card cardTitle cardInside2 text-white mx-5 my-4"
                          title={rowData.projectDescription}
                          onClick={this.onHandleApp.bind(this, rowData)}
                          style={{
                            width: "14rem",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                            transition: "transform 0.3s ease",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "scale(0.95)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <div className="card-body d-flex align-items-center justify-content-center">
                            <p className="card-text">{rowData.projectName}</p>
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            </div> */}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default HeaderSection;
